import request from '@/utils/request';
//卡面分页数据
export function queryStoreCardPage(values) {
  return request('/activityStoreCard/queryStoreCardPage', {
    method: 'POST',
    data: values,
  });
}
//删除活动
export function activityDelete(values) {
  return request('/activity/deleteEvent', {
    method: 'POST',
    data: values,
  });
}
